import {
  DxDiagnosisResult,
  DxDiagnosisResultAdviceContent,
} from '@src/api/types/shared/dxDiagnosis.ts';
import { DxDiagnosisResultMaturityEnum } from '@src/enum/dxDiagnosisResultMaturityEnum.ts';
import { DxDiagnosisStepCodeEnum } from '@src/enum/dxDiagnosisStepCodeEnum.ts';

import { ApiResult } from '../../apiClient/apiResult';
import { axiosClient } from '../../apiClient/axiosClient';
import { Pagination } from '../../types/pagination';

type DxDiagnosisResultIndexRequest = {
  keyword?: string;
  page?: number;
  per_page?: number;
  sort?: string;
  direction?: string;
  status?: number[];
};

type DxDiagnosisResultIndexResponse = {
  data: DxDiagnosisResult[];
  pagination: Pagination;
};

type DxDiagnosisResultAdvice = {
  steps: {
    id: number;
    name: string;
    code: string;
  }[];
  content: DxDiagnosisResultAdviceContent;
  support_services: {
    id: number;
    title: string;
  }[];
};

export type DxDiagnosisResultStep = {
  code: DxDiagnosisStepCodeEnum;
  name: string;
  score: number;
  questions: {
    question_no: number;
    question_text: string;
    max_score: number;
    answer: {
      chosen_text: string;
      score: number;
    };
  }[];
};

export type DxDiagnosisResultShowResponse = {
  diagnosis_on: string;
  company: {
    id: number;
    name: string;
    industry_text: string;
  };
  version: string;
  total_score: number;
  stage: {
    code: DxDiagnosisResultMaturityEnum;
    name: string;
  };
  steps: DxDiagnosisResultStep[];
  advice: DxDiagnosisResultAdvice;
};

type DxDiagnosisResultScoreIndexRequest = {
  company_id: number;
};

export type DxDiagnosisResultCsvExportRequest = {
  status?: number[];
  keyword?: string;
  sort?: string;
  direction?: string;
};

type DxDiagnosisResultScore = {
  total_score: number;
  diagnosis_on: string;
};

type DxDiagnosisResultScoreUser = {
  id: number;
  family_name: string;
  first_name: string;
};

export type DxDiagnosisResultScoreIndexResponse = {
  company_user: DxDiagnosisResultScoreUser;
  scores: DxDiagnosisResultScore[];
}[];

export const dxDiagnosisResultApiClient = {
  index: async (
    params: DxDiagnosisResultIndexRequest = {},
  ): Promise<ApiResult<DxDiagnosisResultIndexResponse>> => {
    return await axiosClient.get('/tenant/dx-diagnosis-results', { params });
  },
  show: async (id: number): Promise<ApiResult<DxDiagnosisResultShowResponse>> => {
    return await axiosClient.get(`/tenant/dx-diagnosis-results/${id}`);
  },
  scoreIndex: async (
    params: DxDiagnosisResultScoreIndexRequest,
  ): Promise<ApiResult<DxDiagnosisResultScoreIndexResponse>> => {
    return await axiosClient.get('/tenant/dx-diagnosis-results/score', { params });
  },
  exportCsv: async (
    params: DxDiagnosisResultCsvExportRequest = {},
  ): Promise<ApiResult<Blob, never>> => {
    return await axiosClient.get('/tenant/dx-diagnosis-results/csv-export', {
      params,
      responseType: 'blob',
    });
  },
};
